import type { Locale } from "./catalogs.js";

const ar = {
  receipt: "وصل أداء رسمي",
  cashReceipt: "وصل قبض نقدي رسمي",
  acknowledgement: "إشعار التوصل بأداة دفع",
  pendingCheque: "شيك في انتظار التحصيل",
  pendingTransfer: "تحويل في انتظار التحصيل",
  pending: "في انتظار التحصيل",
  rejected: "مرفوض · لم يتم أداء الالتزامات",
  cancelled: "ملغى",
  placeholder: "هوية المدرسة والنص القانوني: عناصر مؤقتة غير إنتاجية",
  reference: "المرجع",
  student: "التلميذ(ة)",
  class: "المستوى",
  received: "تاريخ الاستلام",
  settled: "تاريخ الأداء",
  method: "الطريقة",
  cash: "نقداً",
  cheque: "شيك",
  transfer: "تحويل",
  allocations: "تفصيل التخصيص",
  amount: "المبلغ",
  partial: "جزئي",
  remaining: "المتبقي بعد الأداء",
  total: "المجموع",
  lifecycle: "الحالة",
  cancellationReason: "سبب الإلغاء",
  print: "طباعة أو حفظ PDF",
  printAction: "فتح نافذة الطباعة",
  printHelp: "يحدد المتصفح الطابعة أو مكان حفظ PDF.",
  download: "تنزيل الوصل",
  arabic: "العربية",
  french: "Français",
  unavailable: "الوصل غير متاح",
  unavailableHelp: "تعذر فتح هذا الوصل.",
} as const;

const fr = {
  receipt: "Reçu officiel de paiement",
  cashReceipt: "Reçu officiel de paiement en espèces",
  acknowledgement: "Accusé de réception d’un instrument de paiement",
  pendingCheque: "Chèque en attente d’encaissement",
  pendingTransfer: "Virement en attente d’encaissement",
  pending: "EN ATTENTE D’ENCAISSEMENT",
  rejected: "REJETÉ · les obligations ne sont pas réglées",
  cancelled: "ANNULÉ",
  placeholder: "Identité scolaire et mentions légales : éléments provisoires non productifs",
  reference: "Référence",
  student: "Élève",
  class: "Niveau",
  received: "Date de réception",
  settled: "Date de règlement",
  method: "Mode",
  cash: "Espèces",
  cheque: "Chèque",
  transfer: "Virement",
  allocations: "Détail des affectations",
  amount: "Montant",
  partial: "Partiel",
  remaining: "Reste dû après paiement",
  total: "Total",
  lifecycle: "État",
  cancellationReason: "Motif de l’annulation",
  print: "Imprimer ou enregistrer en PDF",
  printAction: "Ouvrir la fenêtre d’impression",
  printHelp: "Le navigateur choisit l’imprimante ou la destination PDF.",
  download: "Télécharger le reçu",
  arabic: "العربية",
  french: "Français",
  unavailable: "Reçu indisponible",
  unavailableHelp: "Ce reçu ne peut pas être ouvert.",
} as const satisfies Record<keyof typeof ar, string>;

export type DocumentMessageKey = keyof typeof ar;

export function documentMessages(locale: Locale): Record<DocumentMessageKey, string> {
  return locale === "ar" ? ar : fr;
}
